import { toast } from '@/hooks'
import { useFoldersStore } from '@/modules/folders'
import { useProjectsStore } from '@/modules/projects/stores'
import type { Project } from '@/modules/projects/stores/types'

const showSuccess = (projects: Project[], verb: string) => () =>
  toast({
    title:
      projects.length === 1
        ? `Project ${verb}`
        : `${projects.length} projects ${verb}`,
    theme: 'success',
  })

const showFailure = (title: string) => (error: Error) =>
  toast({ title, description: error.message, theme: 'destructive' })

// A folder hides when its last project is archived and comes back on unarchive.
const refetchFolders = () =>
  useFoldersStore.getState().loaders.fetchFolders('project')

export const archiveProjects = async (projects: Project[]) => {
  await useProjectsStore
    .getState()
    .mutations.archiveProjects(projects)
    .then(
      showSuccess(projects, 'archived'),
      showFailure("We couldn't archive every project"),
    )
  await refetchFolders()
}

export const unarchiveProjects = async (projects: Project[]) => {
  await useProjectsStore
    .getState()
    .mutations.unarchiveProjects(projects)
    .then(
      showSuccess(projects, 'unarchived'),
      showFailure("We couldn't unarchive every project"),
    )
  await refetchFolders()
}
